const ADMINISTRADOR = 'Administrador'
const RECEPCIONISTA = 'Recepcionista'
const PROFISSIONAL = 'Profissional'
const FATURISTA = 'Faturista'
const GERENTE = 'Gerente'
const SUPERVISAO = 'Supervisao'

export default {
  ADMINISTRADOR,
  RECEPCIONISTA,
  FATURISTA,
  PROFISSIONAL,
  GERENTE,
  SUPERVISAO,
  valores: [
    { descricao: ADMINISTRADOR },
    { descricao: RECEPCIONISTA },
    { descricao: FATURISTA },
    { descricao: PROFISSIONAL },
    { descricao: GERENTE },
    { descricao: SUPERVISAO },
  ],
}
